import { FileExcelOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AreaFilter from "../../components/discount-areas/area-filter";
import AreaTable from "../../components/discount-areas/area-table";
import SearchFilterCard from "../../components/general/filter-card";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import AppContext from "../../context/app/context";
import AreaContext from "../../context/discount-areas/context";
import AreaContextProvider from "../../context/discount-areas/provider";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import ExportToExcelModal from "../../components/general/excel/export-to-excel-modal";
import {
  IExportAreaExcel,
  colomnsExportAreaExcel,
} from "../../models/discount-areas/request";
import TemplateExportExcel from "../../components/general/excel/expor-excel";
interface IProps {
  children?: React.ReactNode;
}

const JopTile: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();
  const [exportModalVisible, setExportModalVisible] = useState(false);

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(AreaContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("discount-areas")}
        subTitle={t("discount_areas_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <>
            <Button
              type="primary"
              onClick={() => {
                setExportModalVisible(true);
              }}
              icon={<FileExcelOutlined />}
            >
              {t("export_to_excel")}
            </Button>
            <Divider key={5} type="vertical" />
            <Button
              type="primary"
              onClick={() => {
                navigate(`/discount-areas/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_discount_area")}
            </Button>
          </>
        ]}
      />
      <ExportToExcelModal
        id="export-category"
        title={t("export_to_excel")}
        visible={exportModalVisible}
        toggleVisible={setExportModalVisible}
        width="50vw"
        defaultValues={
          {
            city: false,
            name: false,
            note: false,
            status: false,
          } as IExportAreaExcel
        }
        loading={loading.includes("create")}
        onSubmit={async (columnsNames) => {
          // await a(columnsNames);
          await actions.exportExcel(columnsNames);
          setExportModalVisible(false);
        }}
      >
        <TemplateExportExcel names={colomnsExportAreaExcel} />
      </ExportToExcelModal>
      <SearchFilterCard
        formId="discount-area-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
          const form = document.getElementById("discount-area-filter");
          if (form) {
            form.dispatchEvent(new Event("reset", { cancelable: true, bubbles: true }));
          }
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <AreaFilter />
      </SearchFilterCard>

      <AreaTable />
    </div>
  );
};

const AreaPage = () => {
  return (
    <AreaContextProvider>
      <JopTile />
    </AreaContextProvider>
  );
};
export default AreaPage;
